namespace Roodik.Core
{
	import DisplayObject = PIXI.DisplayObject;
	import Slot = dragonBones.Slot;
	
	export class Sprite extends PIXI.Container implements ISprite
	{
		private _armature:dragonBones.Armature;
		private _playedAnimations:Array<AnimatedSlot>;

		constructor(private _name?:string)
		{
			super();
			
			if (this._name != undefined && this._name != null)
			{
				const factory = dragonBones.PixiFactory.factory;
				const armatureDisplay = factory.buildArmatureDisplay(this._name);
				this._armature = armatureDisplay.armature;
				this.addChild(armatureDisplay);
			}
			
			this._playedAnimations = new Array<AnimatedSlot>();
		}
		
		public childByName(name:string):Slot
		{
			return this._armature.getSlot(name);
		}
		
		public addChild(display:DisplayObject)
		{
			super.addChild(display);
		}
		
		public playChildAnimation(childName:string, animationName:string, completeCallback:()=>void = null)
		{
			let animatedSlot = new AnimatedSlot(this.childByName(childName), childName, animationName, completeCallback);
			animatedSlot.play();
			
			this._playedAnimations.push(animatedSlot);
		}
		
		public stopChildAnimation(childName:string, animationName:string, frame:number = 0)
		{
			let key = childName+"_"+animationName;
			for(let i:number = 0; i < this._playedAnimations.length; i++)
			{
				if (this._playedAnimations[i].name === key)
				{
					this._playedAnimations[i].stop(frame);
					this._playedAnimations.splice(i,1);
					break;
				}
			}
		}
		
		public get rotation ():number { return this._armature.display.rotation; }
		public set rotation (value:number) { this._armature.display.rotation = value; }
		
		public destroy()
		{
			for(let i:number = 0; i < this._playedAnimations.length; i++)
			{
				this._playedAnimations[i].destroy();
			}
			this._playedAnimations = null;
			
			super.destroy();
		}
	}
	
	export class AnimatedSlot
	{
		private _loopComplete:()=>void;
		
		constructor(private _child:Slot,
		            private _childName:string,
		            private _animationName:string,
		            private _completeCallback:()=>void)
		{
		
		}
		
		public play()
		{
			if (this._child != null)
			{
				let childArmature = this._child.childArmature;
				if (this._completeCallback != null)
				{
					this._loopComplete = ()=>
					{
						this._completeCallback();
					};
					childArmature.eventDispatcher.addDBEventListener("loopComplete", this._loopComplete, this);
				}
				childArmature.animation.play(this._animationName);
			}
		}
		
		public stop(frame:number = 0)
		{
			if (this._child != null)
			{
				let childArmature = this._child.childArmature;
				childArmature.animation.gotoAndStopByFrame(this._animationName, frame);
				// childArmature.animation.stop(this._animationName);
				childArmature.eventDispatcher.removeDBEventListener("loopComplete", this._loopComplete, this);
				this._loopComplete = null;
			}
		}
		
		public get name():string { return this._childName + "_" + this._animationName; }
		
		public destroy()
		{
			this.stop();
			
			this._child = null;
			this._childName = null;
			this._completeCallback = null;
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Base/Sprite.ts